// src/router/layoutRoutes.ts
import { RouteRecordRaw } from 'vue-router';
import Layout from '@/components/Layout.vue';
import Layout1 from '@/components/pages/temp/Layout1.vue';
import Layout2 from '@/components/pages/temp/Layout2.vue';
import Layout3 from '@/components/pages/temp/Layout3.vue';
import Layout4 from '@/components/pages/temp/Layout4.vue';
import Layout5 from '@/components/pages/temp/Layout5.vue';

/**
 * 用于Element-Plus 学习调查用的临时路由
 */
const layoutRoutes: Array<RouteRecordRaw> = [
    {
        path: '/temp',
        component: Layout,
        children: [
            {
                path: 'Layout1',
                name: 'Layout1',
                component: Layout1,
            },
            {
                path: 'Layout2',
                name: 'Layout2',
                component: Layout2,
            },
            {
                path: 'Layout3',
                name: 'Layout3',
                component: Layout3,
            },
            {
                path: 'Layout4',
                name: 'Layout4',
                component: Layout4,
            },
            {
                path: 'Layout5',
                name: 'Layout5',
                component: Layout5,
            }
        ]
    }
];

export default layoutRoutes;